import React from 'react'

const BearLoader = () => {
  return (
    <div className='bear'>

      <span class="loader"></span>
    </div>

  )
}

export default BearLoader